// extracted by mini-css-extract-plugin
module.exports = {"tabTitle":"tabTitle-3eNozaAa clearfix","tabHead":"tabHead-2DwToffd"};